import Events from '@oilstone/events';
import {Provider} from '@oilstone/container';

export default new Provider().register(container => {
    container.singleton('events', () => {
        return new Events();
    })
});
